module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.visibleDevelop()) ? _c('div', {
    staticClass: "foo"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "50%",
      "border-radius": "10px",
      "margin": "20px",
      "background": "white",
      "color": "#1a1a1a"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "trainings"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "85vh"
    },
    attrs: {
      "zoom": 14,
      "center": _vm.center,
      "options": _vm.options
    }
  }, _vm._l((_vm.locationMarkers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "label": m.desc,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70f7b884!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Tracking.vue
// module id = 495
// module chunks = 1